export const CircleAiDotsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 40 40"
    fill="var(--color-icon-primary)"
    aria-hidden
  >
    <circle cx="25.5" cy="14.5" r="4.5" />
    <circle cx="25.5" cy="25.5" r="4.5" />
    <circle cx="14.5" cy="25.5" r="4.5" />
    <circle cx="14.5" cy="14.5" r="4.5" />
  </svg>
);
